export default "__VITE_ASSET__DKqErRdE__"